import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import EditorCanvas from '../components/EditorCanvas';
import {filterApplicableEdits, ImagesRecord, loadImages, onTransformationChange, updateImages} from '../actions/EditorCanvasActions'
import {onEdit} from '../actions/EditHistoryActions'
import {apiRoot} from '../Api';
import isEmpty from 'lodash/isEmpty';
import {ORIGINAL} from '../Constants';
import {PAN, ZOOMIN, ZOOMOUT} from 'rc-canvas/lib/ZoomPanModes';
import {BRUSH, INVERSE, LASSO, FREEHAND, RECT} from 'rc-canvas/lib/DrawingModes';
import Loading from '../components/Loading';
import {openImageContextSelector} from '../reducers/openImageContextSelector';

@connect((state) => ({
    editorCanvas: state.editorCanvas,
    openImageContext: openImageContextSelector(state),
    controlPanel: state.controlPanel
}), {
    loadImages,
    updateImages,
    onEdit,
    onTransformationChange,
}, null, {withRef: true})
export default class EditorCanvasContainer extends Component {
    static propTypes = {
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        srcPrefix: PropTypes.string,
        controlPanel: PropTypes.shape({
            brushSize: PropTypes.number,
            shape: PropTypes.oneOf([FREEHAND, RECT, null]),
            tool: PropTypes.oneOf([BRUSH, LASSO, INVERSE, PAN, ZOOMIN, ZOOMOUT, null]),
        }),
        openImageContext: PropTypes.shape({
            id: PropTypes.number,
            userId: PropTypes.number,
            imageInfo: PropTypes.object,
            images: PropTypes.object,
            userImages: PropTypes.object,
            users: PropTypes.object,
            spread: PropTypes.number,
            amplitude: PropTypes.number,
            openImage: PropTypes.shape({
                isOriginalActive: PropTypes.bool,
                activeImage: PropTypes.string,
            }),
            imageEditHistory: PropTypes.object,
        }),
        loadImages: PropTypes.func,
        updateImages: PropTypes.func,
        onEdit: PropTypes.func,
        highlight: PropTypes.object,
        editorCanvas: PropTypes.shape({
            loading: PropTypes.bool,
            imagesRecord: PropTypes.instanceOf(ImagesRecord),
        }),
        focusOnMount: PropTypes.bool,
        onTransformationChange: PropTypes.func,
        onToggleOriginal: PropTypes.func,
    };

    static defaultProps = {
        srcPrefix: apiRoot
    };

    componentDidMount() {
        const {openImageContext: {imageInfo, amplitude, spread, imageEditHistory: {edits}}, srcPrefix} = this.props;
        this.props.loadImages({imageInfo, amplitude, spread, srcPrefix}, edits);
    }

    componentWillReceiveProps(nextProps) {
        const {openImageContext: {id, imageInfo, amplitude, spread, imageEditHistory: {edits}}, srcPrefix} = nextProps;
        if (srcPrefix !== this.props.srcPrefix ||
            id !== this.props.openImageContext.id ||
            spread !== this.props.openImageContext.spread || amplitude !== this.props.openImageContext.amplitude) {
            nextProps.loadImages({imageInfo, amplitude, spread, srcPrefix}, edits);
        } else if (edits !== this.props.openImageContext.imageEditHistory.edits) {
            const {editorCanvas: {imagesRecord}} = nextProps;
            const origImageData = imagesRecord.origImageData;
            const cleanPoppedImageData = imagesRecord.cleanPoppedImageData;
            const cleanEnhImageData = imagesRecord.cleanEnhImageData;
            nextProps.updateImages({origImageData, cleanPoppedImageData, cleanEnhImageData}, edits);
        }
    }

    resetView = (e) => {
        this.editorCanvas.resetView(e);
    };

    handleDownload = (fileName, type) => {
        this.editorCanvas.saveAs(fileName, type);
    };

    handlePrint = () => {
        this.editorCanvas.print();
    };

    render() {
        const {width, height, openImageContext, editorCanvas} = this.props;
        const {imageInfo, amplitude, spread, openImage} = openImageContext;
        if (isEmpty(imageInfo) || isEmpty(editorCanvas)) {
            return false;
        }
        const {imagesRecord, loading} = editorCanvas;
        if (!imagesRecord) {
            return <Loading style={{width, height: height - 10}}/>;
        }
        if (loading) {
            console.log('loading the same image with different parameters');
        }
        const {origImageData, poppedImageData, enhImageData} = imagesRecord;
        const {srcPrefix, controlPanel, highlight, focusOnMount, openImageContext: {imageEditHistory: {edits}}} = this.props;
        const {tool, shape, brushSize, eraseBoostLevel} = controlPanel;
        const {activeImage, isOriginalActive} = openImage;
        const transformation = editorCanvas.transformation;

        return (
            <EditorCanvas
                width={width}
                height={height}
                srcPrefix={srcPrefix}
                imageInfo={imageInfo}
                activeImage={isOriginalActive ? ORIGINAL : activeImage}
                tool={tool}
                shape={shape}
                brushSize={brushSize}
                eraseBoostLevel={eraseBoostLevel}
                amplitude={amplitude}
                spread={spread}
                highlight={highlight}
                origImageData={origImageData}
                poppedImageData={poppedImageData}
                enhImageData={enhImageData}
                onEdit={(historyItem) => this.props.onEdit(imageInfo.id, historyItem)}
                ref={c => this.editorCanvas = c}
                focusOnMount={focusOnMount}
                edited={filterApplicableEdits(edits).length > 0}
                transformation={transformation}
                onTransformationChange={this.props.onTransformationChange}
                onToggleOriginal={this.props.onToggleOriginal}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/EditorCanvasContainer.js